import { ArrowRight } from "lucide-react";
import { waLink, BRAND, VIDEOS } from "../../lib/site";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full min-h-[100vh] overflow-hidden bg-ink"
    >
      {/* Cinematic looping hero video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster={VIDEOS.heroPoster}
        className="absolute inset-0 w-full h-full object-cover scale-[1.02]"
      >
        <source src={VIDEOS.hero} type="video/mp4" />
      </video>

      {/* Layered overlays for legibility */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/15" />
      <div
        className="absolute inset-0 mix-blend-overlay opacity-40"
        style={{
          background:
            "radial-gradient(80% 60% at 25% 60%, rgba(45,31,88,0.55), transparent 65%)",
        }}
      />
      <div className="absolute inset-0 grain" aria-hidden />

      <div className="relative z-10 container-narrow min-h-[100vh] flex flex-col justify-end pb-24 md:pb-32 pt-44 md:pt-56">
        <div className="max-w-2xl animate-fade-up">
          <span className="overline text-gold-soft">Indore · Since 1995 · Bridal Atelier</span>
          <p className="mt-4 font-hindi text-2xl md:text-3xl text-gold-soft tracking-wide">
            {BRAND.nameHindi}
          </p>
          <h1 className="mt-3 font-serif text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] text-cream">
            We breathe in <span className="italic text-gold-soft">colours</span>
            <br />
            and elegance.
          </h1>
          <p className="mt-7 max-w-xl text-cream/85 text-base md:text-lg leading-relaxed">
            From handloom Banarasi to bridal Kanjeevaram — discover sarees curated
            with three decades of love at New Varsha, on Airport Road, Indore.
            Visit our boutique or message us; we'll help you find the one.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={waLink("Hi! I'd like to order / inquire about your sarees.")}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-order-cta"
              className="btn-ghost"
            >
              Order on WhatsApp
              <ArrowRight size={16} />
            </a>
            <a
              href="#collection"
              data-testid="hero-browse-cta"
              className="text-cream text-sm tracking-[0.22em] uppercase border-b border-cream/60 hover:border-gold hover:text-gold-soft pb-1 transition-all"
            >
              Browse Collection
            </a>
          </div>
        </div>

        <div className="mt-14 md:mt-20 hidden md:flex items-end justify-between text-cream/70">
          <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase">
            <span className="w-12 h-px bg-gold/70" />
            Scroll to explore
          </div>
          <div className="text-right text-[11px] tracking-[0.3em] uppercase">
            Authentic weaves · Hand-picked · Pan-India shipping
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
